export enum ENoticeUrl {
  NOTICES = 'notices',
}
